export default __webpack_public_path__ + "3aafdf0641262e5c3037b90b2cab738f.ttf";